import Cookie from 'common/services/util/-RFC.Cookie';
/**
 * @description
 * Controller for /debug route
 */
angular.module('controllers')
    .controller('forceDebug', ($rootScope, $state, $location, $window) => {

        const cookieConfig = CWCONFIG.cookie;
        const { domain } = cookieConfig;

        if ($state.params.deviceId) {

            $rootScope.State.deviceId = $state.params.deviceId;

        }

        Cookie.set(cookieConfig.debug, true, { path: '/', domain });

        $location.path('/auth/login');

        setTimeout(() => {

            $window.location.reload();

        }, 300);


    });



// WEBPACK FOOTER //
// ./scripts/controllers/forceDebug.js